import React, { useState, useEffect } from 'react';
import Wheel from './Wheel';
import './App.css';

const App = () => {
  const getColor = (index) => {
    const colors = ['#594BF8', '#009BFD', '#1BF182', '#AEE100', '#FEB202', '#FF830E', '#FE3859'];
    return colors[index % colors.length];
  };

  // Initial entries with colors already assigned
  const [entries, setEntries] = useState([
    { name: 'Liam', color: getColor(4), active: true },
    { name: 'Amina', color: getColor(5), active: true },
    { name: 'Jin', color: getColor(0), active: true },
    { name: 'Sofia', color: getColor(1), active: true },
    { name: 'Daan', color: getColor(2), active: true },
    { name: 'Tariq', color: getColor(3), active: true },
    { name: 'Kai', color: getColor(4), active: true },
    { name: 'Eli', color: getColor(1), active: true },
    { name: 'Chloe', color: getColor(5), active: true },
    { name: 'Raj', color: getColor(0), active: true },
    { name: 'Yuki', color: getColor(8), active: true },
  ]);

  const [textareaContent, setTextareaContent] = useState(entries.map(entry => entry.name).join('\n'));
  const [triggerSpin, setTriggerSpin] = useState(false);
  const [winner, setWinner] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [winnersList, setWinnersList] = useState([]);
  const [isSpinning, setIsSpinning] = useState(false);
  const [showTextarea, setShowTextarea] = useState(true);

  const handleTextareaChange = (e) => {
    const content = e.target.value;

    const validLines = content
      .split('\n')
      .map((line) => line.trim())
      .filter((line) => line);

    // Map new lines to entries with the correct color
    setEntries(validLines.map((line, index) => ({
      name: line,
      color: getColor(index),
      active: true,
    })));
    setTextareaContent(content);
  };

  const resetEntries = () => {
    setEntries([]); // Clear entries
    setTextareaContent(''); // Clear the textarea
    setWinnersList([]); // Clear the winners list when resetting
  };

  const handleWheelSpinComplete = (winningEntry) => {
    setWinner(winningEntry);
    setWinnersList(prevWinners => [...prevWinners, winningEntry]);
    setShowPopup(true);
    document.activeElement.blur();
  };

  const handleKeyPress = (e) => {
    if (showPopup) {
      if (e.key === 'r' || e.key === 'R') {
        removeWinner();
      } else if (e.key === 'k' || e.key === 'K') {
        keepWinner();
      }
    } else if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
      setTriggerSpin(true);
    }
  };

  const removeWinner = () => {
    if (winner) {
      // Remove the winner from the entries
      const newEntries = entries.filter(entry => entry.name !== winner);
      setEntries(newEntries);

      // Remove the winner from the textarea content
      const newTextareaContent = newEntries.map(entry => entry.name).join('\n');
      setTextareaContent(newTextareaContent);
    }
    closePopup();
  };

  const keepWinner = () => {
    closePopup();
  };

  const closePopup = () => {
    setWinner(null);
    setShowPopup(false);
  };

  const toggleTextarea = () => {
    setShowTextarea(!showTextarea);
  };

  useEffect(() => {
    const keyDownListener = (e) => handleKeyPress(e);
    window.addEventListener('keydown', keyDownListener);
    return () => {
      window.removeEventListener('keydown', keyDownListener);
    };
  }, [showPopup, winner]);

  return (
    <div className="app-container">
      <div className="navbar">
        <h1>Spinning Wheel</h1>
        <button onClick={toggleTextarea}>
          {showTextarea ? 'Hide ' : 'Show '} Name Box
        </button>
      </div>

      <div className="main-content">
        <div className="textarea-container">
          {showTextarea && (
            <>
              <textarea
                value={textareaContent}
                placeholder="Type or paste names here, one per line"
                onChange={handleTextareaChange}
                className="bulk-textarea"
                disabled={isSpinning}
              />
              <div className="button-container">
                <button onClick={resetEntries} className="reset-button" disabled={isSpinning}>
                  Reset
                </button>
                <button onClick={() => setTriggerSpin(true)} className="spin-button" disabled={isSpinning}>
                  Spin the Wheel
                </button>
              </div>
            </>
          )}

          <div className="winners-container">
            <h2>Winners</h2>
            <ol>
              {winnersList.map((winner, index) => (
                <li key={index}>{winner}</li>
              ))}
            </ol>
          </div>
        </div>

          <Wheel
            entries={entries}
            triggerSpin={triggerSpin}
            setTriggerSpin={setTriggerSpin}
            onSpinComplete={handleWheelSpinComplete}
            isSpinning={isSpinning}
            setIsSpinning={setIsSpinning}
          />
      </div>

      {showPopup && (
        <>
          <div className="overlay" onClick={closePopup}></div>
          <div className="modal">
            <div className="modal-content">
              <h2>Winner: {winner}</h2>
              <p>Press <b>R</b> to remove or <b>K</b> to keep the winner.</p>
              <div className="modal-buttons">
                <button onClick={removeWinner} className="modal-button remove-button">
                  Remove
                </button>
                <button onClick={keepWinner} className="modal-button keep-button">
                  Keep
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default App;